import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'first_name', headerName: 'First Name', width: 200 },
  { field: 'last_name', headerName: 'Last Name', width: 200 },
  { field: 'email', headerName: 'Email', width: 200 },
];

export const suggestionPrimaryKey = 'first_name';
export const suggestionSecondaryKeys = ['email'];

export const initialValues = (accountManager) => ({
  firstName: get(accountManager, 'first_name', ''),
  lastName: get(accountManager, 'last_name', ''),
  email: get(accountManager, 'email', ''),
  rate: get(accountManager, 'rate', ''),
});

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('field is required'),
  lastName: Yup.string().required('field is required'),
  email: Yup.string().required('field is required'),
  rate: Yup.number().required('field is required'),
});
